import type { IntlShape } from 'react-intl'
import type { MeterDetailHeader, MeterWithReadingsHeader } from './types'

export const meterDetailHeaders: MeterDetailHeader[] = [
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Mittari',
				description: 'Table column header for meter detail table: Meter',
			}),
		key: 'meter',
		type: 'text',
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Huoneisto',
				description: 'Table column header for meter registry: Apartment',
			}),
		key: 'apartmentUUID',
		type: 'apartmentOptions',
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Tyyppi',
				description: 'Table column header for meter reading: Type',
			}),
		key: 'type',
		type: 'meterType',
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Sisäänlukutapa',
				description: 'Reading method',
			}),
		key: 'readingMethod',
		type: 'readingMethod',
	},
]

export const meterWithReadingsHeaders: MeterWithReadingsHeader[] = [
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'UUID',
				description: 'Table column header for meter reading: UUID',
			}),
		key: 'uuid',
		show: false,
		sortable: true,
		type: 'text',
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Mittari',
				description: 'Table column header for meter reading: Meter',
			}),
		key: 'meter',
		show: true,
		sortable: true,
		type: 'text',
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Huoneisto',
				description: 'Table column header for meter reading: Apartment',
			}),
		key: 'apartmentUUID',
		show: true,
		sortable: true,
		type: 'apartmentOptions',
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Tyyppi',
				description: 'Table column header for meter reading: Type',
			}),
		key: 'type',
		show: true,
		sortable: true,
		type: 'meterType',
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Laskutuspäivä',
				description: 'Table column header for meter reading: Invoicing date',
			}),
		key: 'invoicingDate',
		show: true,
		sortable: true,
		type: 'date',
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Viimeisin mittauspäivä',
				description:
					'Table column header for meter reading: Latest reading date',
			}),
		key: 'latestReadingDate',
		show: true,
		sortable: true,
		type: 'date',
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Viimeisin mittausarvo',
				description: 'Table column header for meter reading: Latest reading',
			}),
		key: 'latestReadingValue',
		show: true,
		sortable: true,
		type: 'text',
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Alkupvm',
				description: 'Table column header for meter reading: Start date',
			}),
		key: 'startDate',
		show: true,
		sortable: true,
		type: 'date',
	},
	{
		title: (intl: IntlShape) =>
			intl.formatMessage({
				defaultMessage: 'Loppupvm',
				description: 'Table column header for meter reading: End date',
			}),
		key: 'endDate',
		show: true,
		sortable: true,
		type: 'date',
	},
]
